module.exports = __webpack_public_path__ + "static/field_trip_img1@2x-b52f825080c3cf827b54639a60ea86fd.jpg";